import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { Home } from 'lucide-react';

const PropertyPage = () => (
  <ServicePageTemplate
    translationPrefix="propertyPage"
    icon={Home}
    color="from-blue-500 to-blue-600"
    accentColor="bg-blue-50 border border-blue-200"
  />
);

export default PropertyPage;
